import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Running = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Running({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 5.3717L6.82547 11.8953C6.65533 12.4057 6.17766 12.75 5.63962 12.75H2.5C2.22386 12.75 2 12.5261 2 12.25V11.75C2 11.4739 2.22386 11.25 2.5 11.25H5.45943L7.81415 4.18585C8.19402 3.04622 9.80598 3.04623 10.1859 4.18585L15 18.6283L17.1745 12.1047C17.3447 11.5943 17.8223 11.25 18.3604 11.25H21.5C21.7761 11.25 22 11.4739 22 11.75V12.25C22 12.5261 21.7761 12.75 21.5 12.75H18.5406L16.1859 19.8141C15.806 20.9537 14.194 20.9538 13.8141 19.8141L9 5.3717Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'running-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Running;
